import { MdOutlineAttribution } from 'react-icons/md';
import { TmdxAvatar, cn } from '@ds';
import { ccResourceTypeNames } from '@lp/features/Scheduler/SchedulerClinicalCoordinators/constants';
import { PCCOnCallResource } from '@lp/features/Scheduler/SchedulerClinicalCoordinators/types';
import { getFullName } from '@/utils/helpers';

type PCCOnCallResourceCellItemProps = {
  isMe: boolean;
  resource: PCCOnCallResource;
};

export const PCCOnCallResourceCellItem = ({ resource, isMe }: PCCOnCallResourceCellItemProps) => {
  const fullName = getFullName(resource.firstName, resource.lastName);

  return (
    <div className={cn('flex items-center gap-1 h-5 px-[3px] rounded w-full', { 'bg-success-40/30': isMe })}>
      <div className="flex items-center justify-center w-4 h-3.5 bg-base-55 rounded-[3px] text-base-5 text-xs-m">
        {ccResourceTypeNames[resource.type]}
      </div>
      <div className="flex items-center gap-0.5 grow truncate">
        <TmdxAvatar size="sm" radius="sm" type="user" src={resource.profilePhoto} name={fullName} />
        <div className="text-s-m text-base-5 truncate">{fullName}</div>
      </div>
      {resource.isManager && <MdOutlineAttribution size={13} className="text-success-20" />}
    </div>
  );
};
